/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Posts_Errors_Failedtocreate2Inputs */

const he_posts_errors_failedtocreate2 = /** @type {(inputs: Posts_Errors_Failedtocreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת הפוסט נכשלה`)
};

const en_posts_errors_failedtocreate2 = /** @type {(inputs: Posts_Errors_Failedtocreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create post`)
};

/**
* | output |
* | --- |
* | "Failed to create post" |
*
* @param {Posts_Errors_Failedtocreate2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const posts_errors_failedtocreate2 = /** @type {((inputs?: Posts_Errors_Failedtocreate2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Posts_Errors_Failedtocreate2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_posts_errors_failedtocreate2(inputs)
	return en_posts_errors_failedtocreate2(inputs)
});
export { posts_errors_failedtocreate2 as "posts_errors_failedToCreate" }